import { createContext, useContext, ReactNode } from "react";
import { LocationData, LOCATIONS, DEFAULT_LOCATION } from "@/lib/locations";

interface LocationContextType {
  location: LocationData;
  isSeattle: boolean;
  isLynnwood: boolean;
  locationId: string;
}

const LocationContext = createContext<LocationContextType | undefined>(undefined);

interface LocationProviderProps {
  children: ReactNode;
  locationId?: string;
}

export function LocationProvider({ children, locationId = DEFAULT_LOCATION }: LocationProviderProps) {
  const location = LOCATIONS[locationId] || LOCATIONS[DEFAULT_LOCATION];

  const value: LocationContextType = {
    location,
    isSeattle: locationId === "seattle",
    isLynnwood: locationId === "lynnwood",
    locationId,
  };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation(): LocationContextType {
  const context = useContext(LocationContext);
  if (context === undefined) {
    // Fallback for hot-reload edge cases - return default location
    console.warn("useLocation called outside LocationProvider - using default location");
    const defaultLocation = LOCATIONS[DEFAULT_LOCATION];
    return {
      location: defaultLocation,
      isSeattle: false,
      isLynnwood: true,
      locationId: DEFAULT_LOCATION,
    };
  }
  return context;
}
